import * as React from 'react';

import Ghost from '../../components/ghost';

import GraphCardGhostState from './GraphCardGhostState';

import './ContentInsightsSummaryGhostState.scss';

const ContentInsightsSummaryGhostState = () => (
    <div className="ContentInsightsSummaryGhostState">
        <GraphCardGhostState />
        <div className="ContentInsightsSummaryGhostState-cta">
            <Ghost borderRadius={6} className="ContentInsightsSummaryGhostState-ctaButton" height={32} />
        </div>
    </div>
);

export default ContentInsightsSummaryGhostState;
